import { createTheme, SimplePaletteColorOptions } from "@mui/material/styles";

// -----------------------------------------------------------------------------

declare module "@mui/material/styles" {
  interface Palette {
    critical?: Palette["primary"];
    high?: Palette["primary"];
    medium?: Palette["primary"];
    low?: Palette["primary"];
    info: Palette["primary"];
    early_access?: Palette["primary"];
    black?: Palette["primary"];
  }

  interface PaletteOptions {
    critical?: PaletteOptions["primary"];
    high?: PaletteOptions["primary"];
    medium?: PaletteOptions["primary"];
    low?: PaletteOptions["primary"];
    info?: PaletteOptions["primary"];
    early_access?: PaletteOptions["primary"];
    black?: PaletteOptions["primary"];
  }

  interface PaletteColorOptions extends SimplePaletteColorOptions {
    mainFaded?: string;
    mainDisabled?: string;
    border?: string;
  }

  interface PaletteColor {
    border?: string;
    mainFaded?: string;
  }
}

// Update the Chip's color prop options
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    black: true;
  }
}

const Theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: "100%",
        },
        body: {
          backgroundColor: "#f8f8f8",
          display: "flex !important",
          flexDirection: "column",
          height: "100%",
        },
        "#root": {
          display: "flex !important",
          flexDirection: "column",
          flexGrow: 1,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          border: 0,
          borderRadius: 0,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "1px rgba(0, 0, 0, 0.1) solid",
          borderRadius: 12,
          boxShadow: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "none",

          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
  },
  palette: {
    mode: "light",
    background: {
      default: "#f8f8f8",
    },
    primary: {
      main: "#1F6BBC",
      mainFaded: "rgba(31, 107, 188, 0.08)",
      mainDisabled: "rgba(31, 107, 188, 0.25)",
      border: "rgba(0, 0, 0, 0.125)",
      contrastText: "#fff",
    },
    black: {
      main: "#000",
      contrastText: "#fff",
    },
    success: {
      main: "#4caf50",
      contrastText: "#fff",
    },
    critical: {
      main: "#de0000",
      contrastText: "#fff",
    },
    high: {
      main: "#ff7700",
      contrastText: "#fff",
    },
    medium: {
      main: "#ebb000",
      contrastText: "#fff",
    },
    low: {
      main: "#0072fe",
      contrastText: "#fff",
    },
    info: {
      main: "#808080",
      contrastText: "#fff",
    },
    early_access: {
      main: "#50c6cc",
      contrastText: "#fff",
    },
  },
});

export default Theme;
